module.exports = __webpack_public_path__ + "assets/b63.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b63.png
// module id = 653
// module chunks = 0